import React from 'react'

const Users = () => {
 return (
  <>
   <h2>i am theUsers page</h2>
  </>
 )
}

export default Users
